"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectWithdrawBank = exports.receiveAccountWithdrawInfos = exports.fetchingAccountWithdrawInfos = exports.fetchAccountWithdrawInfos = exports.accountWithdrawInfosError = exports.SELECT_WITHDRAW_BANK = exports.RECEIVE_ACCOUNT_WITHDRAW_INFOS = exports.FETCHING_ACCOUNT_WITHDRAW_INFOS = exports.DeleteAccountWithdrawInfo = exports.DELETE_WHITELISTED_ADDRESS = exports.CreateAccountWithdrawInfo = exports.ACCOUNT_WITHDRAW_INFOS_ERROR = void 0;
var _reduxForm = require("redux-form");
var _apiActions = require("./apiActions");
var _snackbarActions = require("./snackbarActions");
var _sidePaneActions = require("./sidePaneActions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var FETCHING_ACCOUNT_WITHDRAW_INFOS = exports.FETCHING_ACCOUNT_WITHDRAW_INFOS = 'FETCHING_ACCOUNT_WITHDRAW_INFOS';
var RECEIVE_ACCOUNT_WITHDRAW_INFOS = exports.RECEIVE_ACCOUNT_WITHDRAW_INFOS = 'RECEIVE_ACCOUNT_WITHDRAW_INFOS';
var ACCOUNT_WITHDRAW_INFOS_ERROR = exports.ACCOUNT_WITHDRAW_INFOS_ERROR = 'ACCOUNT_WITHDRAW_INFOS_ERROR';
var SELECT_WITHDRAW_BANK = exports.SELECT_WITHDRAW_BANK = 'SELECT_WITHDRAW_BANK';
var DELETE_WHITELISTED_ADDRESS = exports.DELETE_WHITELISTED_ADDRESS = 'DELETE_WHITELISTED_ADDRESS';
var fetchingAccountWithdrawInfos = exports.fetchingAccountWithdrawInfos = {
  type: FETCHING_ACCOUNT_WITHDRAW_INFOS
};
var receiveAccountWithdrawInfos = exports.receiveAccountWithdrawInfos = function receiveAccountWithdrawInfos(payload) {
  return {
    type: RECEIVE_ACCOUNT_WITHDRAW_INFOS,
    payload: payload
  };
};
var accountWithdrawInfosError = exports.accountWithdrawInfosError = function accountWithdrawInfosError(payload) {
  return {
    type: ACCOUNT_WITHDRAW_INFOS_ERROR,
    payload: payload
  };
};
var selectWithdrawBank = exports.selectWithdrawBank = function selectWithdrawBank(payload) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var withdrawInfos, bank;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            withdrawInfos = getState().eotcWithdraw.withdrawInfos;
            bank = withdrawInfos.find(function (i) {
              return i.AccountWithdrawInfoId === payload;
            });
            if (bank) {
              dispatch((0, _reduxForm.change)('createFiatWithdraw', 'Name', bank['Name']));
              dispatch((0, _reduxForm.change)('createFiatWithdraw', 'AccountIdentifier', bank['AccountIdentifier']));
              dispatch((0, _reduxForm.change)('createFiatWithdraw', 'AccountWithdrawInfoId', bank['AccountWithdrawInfoId']));
              dispatch((0, _reduxForm.change)('createFiatWithdraw', 'BankAccountNumber', "".concat(bank['Name'], " - *").concat(bank['AccountIdentifier'])));
            } else if (payload === 'default') {
              dispatch((0, _reduxForm.change)('createFiatWithdraw', 'Name', ''));
              dispatch((0, _reduxForm.change)('createFiatWithdraw', 'AccountIdentifier', ''));
              dispatch((0, _reduxForm.change)('createFiatWithdraw', 'AccountWithdrawInfoId', ''));
              dispatch((0, _reduxForm.change)('createFiatWithdraw', 'BankAccountNumber', ''));
            }
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var fetchAccountWithdrawInfos = exports.fetchAccountWithdrawInfos = function fetchAccountWithdrawInfos() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var payload, data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch(fetchingAccountWithdrawInfos);
            payload = {
              AccountId: getState().user.selectedAccountId,
              OMSId: getState().user.userInfo.OMSId
            };
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetAccountWithdrawInfos', payload));
          case 1:
            data = _context2.v;
            if (!(data && !Object.prototype.hasOwnProperty.call(data, 'errormsg'))) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2, dispatch(receiveAccountWithdrawInfos(data)));
          case 2:
            return _context2.a(2, dispatch(accountWithdrawInfosError(data.errormsg)));
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var DeleteAccountWithdrawInfo = exports.DeleteAccountWithdrawInfo = function DeleteAccountWithdrawInfo(AccountWithdrawInfoId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, _getState) {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return dispatch((0, _apiActions.callAPI)('DeleteAccountWithdrawInfo', {
              AccountWithdrawInfoId: AccountWithdrawInfoId
            })).then(function (res) {
              if (res.result) {
                dispatch((0, _snackbarActions.showSnack)({
                  id: 'whitelistDeleteSuccess',
                  text: 'Successfully removed address.',
                  type: 'success'
                }));
                dispatch({
                  type: DELETE_WHITELISTED_ADDRESS,
                  payload: AccountWithdrawInfoId
                });
                return;
              }
              dispatch((0, _snackbarActions.showSnack)({
                id: 'whiteListDeleteError',
                text: 'Error deleting address.',
                type: 'warning'
              }));
            });
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var CreateAccountWithdrawInfo = exports.CreateAccountWithdrawInfo = function CreateAccountWithdrawInfo(payload) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var state, data;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            state = getState();
            _context4.n = 1;
            return dispatch((0, _apiActions.callAPI)('CreateAccountWithdrawInfo', _objectSpread(_objectSpread({}, payload), {}, {
              OMSId: state.user.userInfo.OMSId,
              AccountId: state.user.selectedAccountId
            })));
          case 1:
            data = _context4.v;
            if (!data.result) {
              _context4.n = 2;
              break;
            }
            dispatch((0, _snackbarActions.showSnack)({
              id: 'whitelistAddressSuccess',
              text: 'Address whitelisting is pending. Please check your email for next steps.',
              type: 'success'
            }));
            dispatch((0, _sidePaneActions.closeSidePane)());
            return _context4.a(2);
          case 2:
            dispatch((0, _snackbarActions.showSnack)({
              id: 'whitelistAddressError',
              text: "".concat(data.errormsg).concat(data.detail && ": ".concat(data.detail)),
              type: 'warning'
            }));
          case 3:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};